import AdminNavbar from '../../component/adminNavbar';
import {
	Box,
	Button,
	FormControl,
	FormLabel,
	Input,
	Select,
	Textarea,
	Stack,
	Heading,
	Grid,
	GridItem,
	Text,
	HStack,
	IconButton,
	Checkbox,
	Flex,
	Alert,
	AlertIcon,
	VStack,
	Card,
	CardBody,
	SimpleGrid,
	Image,
	Divider,
	Badge,
	useToast,
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalCloseButton,
	ModalBody,
	ModalFooter,
} from '@chakra-ui/react';
import ProductPreviewCard from '../../component/productPreviewCard';
import { buildVariantsPreservingPrices } from '../../utils/variantPricing';
import { AddIcon, ViewIcon, CloseIcon, AttachmentIcon } from '@chakra-ui/icons';
import { connect } from 'react-redux';
import { addProduct } from '../../redux/actions/productActions';
import { getAllCategories } from '../../redux/actions/categoryActions';
import { getAllFacilityList } from '../../redux/actions/facilityActions';
import { getAllPriceGroups } from '../../redux/actions/priceGroupActions';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState, useRef, useCallback } from 'react';
import axios from 'axios';

const BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000';

const SectionCard = ({ title, children }) => (
	<Card bg="white" shadow="sm" borderRadius="lg" overflow="hidden">
		<Box px={6} py={4} bg="gray.50" borderBottomWidth="1px" borderColor="gray.200">
			<Heading size="sm" color="gray.700">{title}</Heading>
		</Box>
		<CardBody px={6} py={5}>
			{children}
		</CardBody>
	</Card>
);

const AddProduct = ({
	addProduct,
	getAllFacilityList,
	facListLoading,
	facList,
	getAllCategories,
	catloading,
	categories,
	priceGroups,
	getAllPriceGroups,
}) => {
	useEffect(() => {
		getAllFacilityList();
		getAllPriceGroups();
		getAllCategories();
	}, []);

	useEffect(() => {
		const unloadCallback = (event) => {
			event.preventDefault();
			event.returnValue = '';
			return '';
		};
		window.addEventListener('beforeunload', unloadCallback);
		return () => window.removeEventListener('beforeunload', unloadCallback);
	}, []);

	const [title, setTitle] = useState('');
	const [file, setFile] = useState<File | null>(null);
	const [fbnumber, setFbnumber] = useState('');
	const [description, setDescription] = useState('');
	const [photo, setPhoto] = useState(null);
	const [category, setCategory] = useState('');
	const [subcategory, setSubcategory] = useState('');
	const [price, setPrice] = useState('');
	const [status, setStatus] = useState('active');
	const [attributes, setAttributes] = useState([]);
	const [addAttribute, setAddAttribute] = useState(false);
	const [variablePrice, setVariablePrice] = useState(false);
	const [facPrices, setFacPrices] = useState([]);
	const [groupPrices, setGroupPrices] = useState<{ groupId: number; price: string }[]>([]);
	const [variants, setVariants] = useState<any[]>([]);
	const [unit, setUnit] = useState('');
	const [quantityPerUnit, setQuantityPerUnit] = useState('');
	const [isSubmitting, setIsSubmitting] = useState(false);
	const [isPreviewOpen, setIsPreviewOpen] = useState(false);
	const [fishbowlUoms, setFishbowlUoms] = useState<{ name: string; abbreviation: string }[]>([]);

	const fileInputRef = useRef(null);
	const navigate = useNavigate();
	const toast = useToast();

	useEffect(() => {
		const loadUoms = async () => {
			try {
				const res = await axios.get(`${BASE_URL}/api/fishbowl/uoms`, {
					headers: { 'x-auth-token': localStorage.getItem('x-auth-token') },
				});
				const uoms = res.data?.uoms || [];
				setFishbowlUoms(uoms);
				if (uoms.length && !unit) {
					const ea = uoms.find((u) => u.abbreviation?.toLowerCase() === 'ea');
					setUnit(ea?.abbreviation || uoms[0].abbreviation);
				}
			} catch {
				setFishbowlUoms([]);
			}
		};
		loadUoms();
	}, []);

	const parentCategories = categories?.filter((c) => !c.parent_id) || [];
	const subcategoriesForSelected = categories?.filter((c) => c.parent_id == category) || [];

	const handleCategoryChange = (e) => {
		setCategory(e.target.value);
		setSubcategory('');
	};

	const handlePriceChange = (facilityId, value) => {
		setFacPrices((prev) => {
			const existing = prev.find((p) => p.facilityId === facilityId);
			if (existing) return prev.map((p) => (p.facilityId === facilityId ? { ...p, price: value } : p));
			return [...prev, { facilityId, price: value }];
		});
	};

	const handleGroupPriceChange = (groupId, value) => {
		setGroupPrices((prev) => {
			const existing = prev.find((g) => g.groupId === groupId);
			if (existing) return prev.map((g) => (g.groupId === groupId ? { ...g, price: value } : g));
			return [...prev, { groupId, price: value }];
		});
	};

	const handlePhotoChange = (event) => {
		const f = event.target.files[0];
		if (f) {
			setPhoto(URL.createObjectURL(f));
			setFile(f);
		}
	};

	const openPreview = (event?) => {
		event?.preventDefault?.();
		if (!title?.trim()) {
			toast({ title: 'Product name is required.', status: 'warning', duration: 2000 });
			return;
		}
		if (!category) {
			toast({ title: 'Category is required.', status: 'warning', duration: 2000 });
			return;
		}
		if (!price && variants.length === 0) {
			toast({ title: 'Price is required (or add variants).', status: 'warning', duration: 2000 });
			return;
		}
		setIsPreviewOpen(true);
	};

	const handleConfirmSave = async () => {
		setIsSubmitting(true);
		try {
			await addProduct({
				title,
				photo: file,
				category,
				subcategory,
				price,
				description,
				attributes,
				unit,
				quantityPerUnit,
				facPrices,
				fbnumber,
				groupPrices: groupPrices.map((g) => ({ groupId: g.groupId, price: parseFloat(g.price) || 0 })),
				variants,
			});
			setIsPreviewOpen(false);
			navigate('/admin/products');
		} catch {
			// error alert dispatched by action
		} finally {
			setIsSubmitting(false);
		}
	};

	const handleSubmit = (event) => {
		event.preventDefault();
		openPreview();
	};

	const handleAddAttribute = () => {
		setAttributes((prev) => [...prev, { attribute_value: '', attribute_name: 'Color', price: '' }]);
	};

	const handleDeleteAttribute = (index) => {
		const updated = attributes.filter((_, i) => i !== index);
		setAttributes(updated);
		if (updated.length === 0) setAddAttribute(false);
	};

	const handleChangeAttribute = useCallback((index, field, value) => {
		setAttributes((prev) => {
			const updated = [...prev];
			updated[index] = { ...updated[index], [field]: value };
			return updated;
		});
	}, []);

	const generateVariants = () => {
		const { variants: next, preservedCount } = buildVariantsPreservingPrices(attributes, variants);
		setVariants(next);
		if (preservedCount > 0) {
			toast({
				title: `Generated ${next.length} variants`,
				description: `Kept pricing on ${preservedCount} matching option(s).`,
				status: 'success',
				duration: 3000,
			});
		} else {
			toast({
				title: `Generated ${next.length} variants`,
				description: 'Set prices for each combination below.',
				status: 'info',
				duration: 3000,
			});
		}
	};

	const handleVariantPriceChange = (vIdx: number, value: string) => {
		setVariants((prev) => prev.map((v, i) => i === vIdx ? { ...v, price: value } : v));
	};

	const handleVariantFacPriceChange = (vIdx: number, facilityId: number, value: string) => {
		setVariants((prev) => prev.map((v, i) => i === vIdx
			? { ...v, facilityPrices: { ...v.facilityPrices, [facilityId]: value } }
			: v));
	};

	const handleVariantGroupPriceChange = (vIdx: number, groupId: number, value: string) => {
		setVariants((prev) => prev.map((v, i) => i === vIdx
			? { ...v, groupPrices: { ...v.groupPrices, [groupId]: value } }
			: v));
	};

	return (
		<>
			<AdminNavbar />
			<Box pt={{ base: 16, md: 6 }} px={{ base: 4, md: 6 }} pb={6} ml={{ base: 0, md: "250px" }} bg="gray.100" minHeight="100vh">
				<Flex align="center" justify="space-between" mb={6} mt={8}>
					<Box>
						<Heading size="lg" color="gray.800">Add Product</Heading>
						<Text fontSize="sm" color="gray.500" mt={1}>Fill in the details to create a new product</Text>
					</Box>
					<Button
						colorScheme="teal"
						leftIcon={<AddIcon />}
						size="lg"
						type="submit"
						form="add-product-form"
						isLoading={isSubmitting}
						loadingText="Saving..."
					>
						Preview & Save
					</Button>
				</Flex>

				<Grid templateColumns={{ base: '1fr', md: '2.5fr 1fr' }} gap={4}>
					<GridItem>
						<form id="add-product-form" onSubmit={handleSubmit}>
							<Stack spacing={4}>
								{/* Basic Information */}
								<SectionCard title="Basic Information">
									<Stack spacing={4}>
										<SimpleGrid columns={{ base: 1, sm: 2 }} spacing={4}>
											<FormControl isRequired>
												<FormLabel fontSize="sm">Product Name</FormLabel>
												<Input
													value={title}
													onChange={(e) => setTitle(e.target.value)}
													placeholder="Enter product name"
													focusBorderColor="teal.400"
												/>
											</FormControl>
											<FormControl>
												<FormLabel fontSize="sm">FB Number</FormLabel>
												<Input
													value={fbnumber}
													onChange={(e) => setFbnumber(e.target.value)}
													placeholder="e.g. FB-12345"
													focusBorderColor="teal.400"
												/>
											</FormControl>
										</SimpleGrid>
										<FormControl>
											<FormLabel fontSize="sm">Description</FormLabel>
											<Textarea
												value={description}
												onChange={(e) => setDescription(e.target.value)}
												placeholder="Describe the product..."
												rows={3}
												focusBorderColor="teal.400"
											/>
										</FormControl>
									</Stack>
								</SectionCard>

								{/* Media & Organization */}
								<SectionCard title="Media & Organization">
									<Stack spacing={4}>
										<FormControl>
											<FormLabel fontSize="sm">Product Photo</FormLabel>
											<Input
												type="file"
												ref={fileInputRef}
												onChange={handlePhotoChange}
												display="none"
												accept="image/*"
											/>
											<HStack>
												<Button
													leftIcon={<AttachmentIcon />}
													onClick={() => fileInputRef.current?.click()}
													variant="outline"
													size="sm"
													colorScheme="gray"
												>
													Choose File
												</Button>
												{file && (
													<HStack>
														<Image
															src={photo}
															boxSize="40px"
															objectFit="cover"
															borderRadius="md"
															border="1px solid"
															borderColor="gray.200"
														/>
														<Text fontSize="sm" color="gray.600" isTruncated maxW="150px">
															{file.name}
														</Text>
														<IconButton
															aria-label="Remove photo"
															icon={<CloseIcon />}
															size="xs"
															variant="ghost"
															colorScheme="red"
															onClick={() => { setFile(null); setPhoto(null); }}
														/>
													</HStack>
												)}
												{!file && (
													<Text fontSize="sm" color="gray.400">No file selected</Text>
												)}
											</HStack>
										</FormControl>

										<SimpleGrid columns={{ base: 1, sm: 2 }} spacing={4}>
											<FormControl>
												<FormLabel fontSize="sm">Status</FormLabel>
												<Select
													value={status}
													onChange={(e) => setStatus(e.target.value)}
													focusBorderColor="teal.400"
												>
													<option value="active">Active</option>
													<option value="inactive">Inactive</option>
												</Select>
											</FormControl>
											<FormControl>
												<FormLabel fontSize="sm">Category</FormLabel>
												<Select
													placeholder="Select category"
													value={category}
													onChange={handleCategoryChange}
													isDisabled={catloading}
													focusBorderColor="teal.400"
												>
													{parentCategories.map((cat) => (
														<option key={cat.category_id} value={cat.category_id}>
															{cat.category_name}
														</option>
													))}
												</Select>
											</FormControl>
										</SimpleGrid>

										{subcategoriesForSelected.length > 0 && (
											<FormControl>
												<FormLabel fontSize="sm">Subcategory</FormLabel>
												<Select
													placeholder="Select subcategory (optional)"
													value={subcategory}
													onChange={(e) => setSubcategory(e.target.value)}
													focusBorderColor="teal.400"
												>
													{subcategoriesForSelected.map((cat) => (
														<option key={cat.category_id} value={cat.category_id}>
															{cat.category_name}
														</option>
													))}
												</Select>
											</FormControl>
										)}
									</Stack>
								</SectionCard>

								{/* Inventory & Pricing */}
								<SectionCard title="Inventory & Pricing">
									<SimpleGrid columns={{ base: 1, sm: 2 }} spacing={4}>
										<FormControl>
											<FormLabel fontSize="sm">Price ($)</FormLabel>
											<Input
												type="number"
												step="0.01"
												value={price}
												onChange={(e) => setPrice(e.target.value)}
												placeholder="0.00"
												focusBorderColor="teal.400"
												onWheel={(e) => e.currentTarget.blur()}
											/>
										</FormControl>
										<FormControl isRequired>
											<FormLabel fontSize="sm">Unit of Measurement</FormLabel>
											<Select
												value={unit}
												onChange={(e) => setUnit(e.target.value)}
												focusBorderColor="teal.400"
												placeholder={fishbowlUoms.length ? 'Select Fishbowl UOM' : 'Sync UOMs from Fishbowl first'}
											>
												{fishbowlUoms.map((u) => (
													<option key={u.abbreviation} value={u.abbreviation}>
														{u.name} ({u.abbreviation})
													</option>
												))}
											</Select>
										</FormControl>
										<FormControl isRequired>
											<FormLabel fontSize="sm">Quantity Per Unit</FormLabel>
											<Input
												type="number"
												min="1"
												value={quantityPerUnit}
												onChange={(e) => setQuantityPerUnit(e.target.value)}
												placeholder="1"
												focusBorderColor="teal.400"
												onWheel={(e) => e.currentTarget.blur()}
											/>
										</FormControl>
									</SimpleGrid>
								</SectionCard>

							{/* Advanced Options */}
					<SectionCard title="Advanced Options">
						<Stack spacing={4}>
							<Checkbox colorScheme="teal" isChecked={addAttribute} onChange={() => {
								if (!addAttribute) handleAddAttribute();
								else { setAttributes([]); setVariants([]); }
								setAddAttribute(!addAttribute);
							}}>
								<Text fontSize="sm">This product has multiple options (e.g. size, color)</Text>
							</Checkbox>

							{addAttribute && (
								<Box p={4} borderWidth="1px" borderRadius="md" borderColor="gray.200" bg="gray.50">
									<Stack spacing={3}>
										<Text fontSize="xs" color="gray.500">Define option types and values. Then click Generate Variants to set a price per combination.</Text>
										{attributes.map((attr, index) => (
											<HStack key={index} spacing={3} align="flex-end">
												<FormControl>
													<FormLabel fontSize="xs" color="gray.600">Type</FormLabel>
													<Select size="sm" value={attr.attribute_name} onChange={(e) => handleChangeAttribute(index, 'attribute_name', e.target.value)} focusBorderColor="teal.400">
														<option value="Color">Color</option>
														<option value="Size">Size</option>
													</Select>
												</FormControl>
												<FormControl>
													<FormLabel fontSize="xs" color="gray.600">Value</FormLabel>
													<Input size="sm" value={attr.attribute_value} onChange={(e) => handleChangeAttribute(index, 'attribute_value', e.target.value)} focusBorderColor="teal.400" />
												</FormControl>
												<IconButton aria-label="Remove option" icon={<CloseIcon />} size="sm" variant="ghost" colorScheme="red" onClick={() => handleDeleteAttribute(index)} />
											</HStack>
										))}
										<HStack>
											<Button size="sm" variant="outline" colorScheme="teal" leftIcon={<AddIcon />} onClick={handleAddAttribute}>Add Option</Button>
											{attributes.length > 0 && <Button size="sm" colorScheme="purple" onClick={generateVariants}>Generate Variants</Button>}
										</HStack>
									</Stack>
								</Box>
							)}

							{variants.length > 0 && (
								<Box p={4} borderWidth="1px" borderRadius="md" borderColor="purple.200" bg="purple.50">
									<Text fontSize="sm" fontWeight="semibold" color="purple.700" mb={3}>Variant Pricing</Text>
									<Stack spacing={3}>
										{variants.map((variant, vIdx) => (
											<Box key={vIdx} p={3} bg="white" borderRadius="md" borderWidth="1px" borderColor="purple.100">
												<HStack justify="space-between" mb={2}>
													<Badge colorScheme="purple">{variant.label}</Badge>
													<HStack>
														<Text fontSize="sm" color="gray.500">Base $</Text>
														<Input size="sm" w="90px" type="number" step="0.01" onWheel={(e) => e.currentTarget.blur()} placeholder="0.00" value={variant.price} onChange={(e) => handleVariantPriceChange(vIdx, e.target.value)} focusBorderColor="purple.400" />
													</HStack>
												</HStack>
												{variablePrice && facList.length > 0 && (
													<VStack spacing={1} align="stretch" pl={2}>
														<Text fontSize="xs" color="gray.500" fontWeight="semibold">Facility overrides:</Text>
														{facList.map((fac) => (
															<HStack key={fac.facilityId} spacing={2}>
																<Text fontSize="xs" color="gray.600" minW="120px">{fac.name}</Text>
																<Text fontSize="xs" color="gray.500">$</Text>
																<Input size="xs" w="70px" type="number" step="0.01" onWheel={(e) => e.currentTarget.blur()} placeholder={variant.price || '0.00'} value={variant.facilityPrices?.[fac.facilityId] ?? ''} onChange={(e) => handleVariantFacPriceChange(vIdx, fac.facilityId, e.target.value)} focusBorderColor="teal.400" />
															</HStack>
														))}
													</VStack>
												)}
												{priceGroups && priceGroups.length > 0 && (
													<VStack spacing={1} align="stretch" pl={2} mt={1}>
														<Text fontSize="xs" color="gray.500" fontWeight="semibold">Price group overrides:</Text>
														{priceGroups.map((group) => (
															<HStack key={group.id} spacing={2}>
																<Text fontSize="xs" color="gray.600" minW="120px">{group.name}</Text>
																<Text fontSize="xs" color="gray.500">$</Text>
																<Input size="xs" w="70px" type="number" step="0.01" onWheel={(e) => e.currentTarget.blur()} placeholder={variant.price || '0.00'} value={variant.groupPrices?.[group.id] ?? ''} onChange={(e) => handleVariantGroupPriceChange(vIdx, group.id, e.target.value)} focusBorderColor="blue.400" />
															</HStack>
														))}
													</VStack>
												)}
											</Box>
										))}
									</Stack>
								</Box>
							)}

							<Divider />

							<Checkbox colorScheme="teal" isChecked={variablePrice} onChange={() => setVariablePrice(!variablePrice)}>
								<Text fontSize="sm">This product has different prices per facility</Text>
							</Checkbox>

							{variablePrice && variants.length === 0 && (
								<Stack spacing={3}>
									<Alert status="info" borderRadius="md" fontSize="sm"><AlertIcon />Facility prices override the default product price.</Alert>
									{facListLoading ? <Text fontSize="sm" color="gray.500">Loading facilities...</Text> : facList.map((fac) => (
										<Card key={fac.facilityId} variant="outline" size="sm">
											<Flex alignItems="center" px={4} py={3} justify="space-between">
												<Text fontSize="sm" fontWeight="medium" flex="1">{fac.name}</Text>
												<HStack>
													<Text fontSize="sm" color="gray.500">$</Text>
													<Input w="100px" size="sm" type="number" step="0.01" onWheel={(e) => e.currentTarget.blur()} value={facPrices.find((p) => p.facilityId === fac.facilityId)?.price ?? price} onChange={(e) => handlePriceChange(fac.facilityId, e.target.value)} focusBorderColor="teal.400" />
													{Number(facPrices.find((p) => p.facilityId === fac.facilityId)?.price ?? price) === 0 && <Badge colorScheme="orange" fontSize="xs">Not sold at facility</Badge>}
												</HStack>
											</Flex>
										</Card>
									))}
								</Stack>
							)}
						</Stack>
					</SectionCard>
					{priceGroups && priceGroups.length > 0 && variants.length === 0 && (
						<SectionCard title="Price Group Pricing">
							<Stack spacing={3}>
								<Text fontSize="xs" color="blue.500" fontWeight="medium">Set a price for each group. Leave blank to use the product default price.</Text>
								{priceGroups.map((group) => {
									const current = groupPrices.find((g) => g.groupId === group.id);
									return (
										<Card key={group.id} variant="outline" size="sm" bg={current ? 'blue.50' : 'transparent'}>
											<Flex alignItems="center" px={4} py={3} justify="space-between">
												<Text fontSize="sm" fontWeight="medium" flex="1">{group.name}</Text>
												<HStack>
													<Text fontSize="sm" color="gray.500">$</Text>
													<Input w="100px" size="sm" type="number" step="0.01" onWheel={(e) => e.currentTarget.blur()} placeholder={price || '0.00'} value={current?.price ?? ''} onChange={(e) => handleGroupPriceChange(group.id, e.target.value)} focusBorderColor="blue.400" />
												</HStack>
											</Flex>
										</Card>
									);
								})}
							</Stack>
						</SectionCard>
					)}
							</Stack>
						</form>
					</GridItem>

					{/* Preview Panel */}
					<GridItem>
						<Box
							p={4}
							bg="white"
							boxShadow="sm"
							borderRadius="lg"
							borderWidth="1px"
							borderColor="gray.200"
							position="sticky"
							top="80px"
						>
							<HStack spacing={2} mb={3}>
								<ViewIcon color="gray.500" />
								<Text fontSize="sm" fontWeight="semibold" color="gray.600">Live Preview</Text>
							</HStack>
							<Divider mb={3} />
							<ProductPreviewCard
								title={title}
								photo={photo}
								price={price}
								description={description}
								attributes={attributes}
								variants={variants}
								unit={unit}
								quantityPerUnit={quantityPerUnit}
							/>
						</Box>
					</GridItem>
				</Grid>
			</Box>

			<Modal isOpen={isPreviewOpen} onClose={() => setIsPreviewOpen(false)} size="lg" isCentered scrollBehavior="inside">
				<ModalOverlay />
				<ModalContent maxH="85vh">
					<ModalHeader>Review Product</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<Stack spacing={4}>
							<Box border="1px solid" borderColor="gray.100" borderRadius="md" overflow="hidden">
								{[
									{ label: 'Name', value: title },
									{ label: 'FB Number', value: fbnumber || '—' },
									{ label: 'Base price', value: price ? `$${parseFloat(price).toFixed(2)}` : '—' },
									{ label: 'Unit', value: unit || 'each' },
									{ label: 'Qty per unit', value: quantityPerUnit || '1' },
									{ label: 'Status', value: status },
									{ label: 'Category', value: parentCategories.find((c) => String(c.id) === String(category))?.name || category || '—' },
									{ label: 'Subcategory', value: subcategoriesForSelected.find((c) => String(c.id) === String(subcategory))?.name || subcategory || '—' },
								].map((row) => (
									<Flex key={row.label} px={3} py={2} justify="space-between" gap={3} borderBottom="1px solid" borderColor="gray.50" fontSize="sm">
										<Text color="gray.500" minW="110px">{row.label}</Text>
										<Text fontWeight="semibold" textAlign="right">{row.value}</Text>
									</Flex>
								))}
							</Box>

							{description?.trim() && (
								<Box>
									<Text fontWeight="semibold" mb={1} fontSize="sm" color="gray.600">Description</Text>
									<Text fontSize="sm" color="gray.700" whiteSpace="pre-wrap">{description}</Text>
								</Box>
							)}

							{file && (
								<Box>
									<Badge colorScheme="purple" mb={2}>Photo attached</Badge>
									<Text fontSize="sm" color="gray.600">{file.name}</Text>
								</Box>
							)}

							{attributes.length > 0 && (
								<Box>
									<HStack mb={2}>
										<Badge colorScheme="cyan">Attributes</Badge>
										<Text fontSize="sm" color="gray.500">{attributes.length}</Text>
									</HStack>
									<Text fontSize="sm" color="gray.600">
										{attributes.map((a) => `${a.attribute_name}: ${a.attribute_value || '—'}`).join(' · ')}
									</Text>
								</Box>
							)}

							{variants.length > 0 && (
								<Box>
									<HStack mb={2}>
										<Badge colorScheme="green">Variants</Badge>
										<Text fontSize="sm" color="gray.500">{variants.length}</Text>
									</HStack>
									<Box border="1px solid" borderColor="green.100" borderRadius="md" overflow="hidden" maxH="200px" overflowY="auto">
										{variants.map((v, i) => (
											<Flex key={`${v.label}-${i}`} px={3} py={2} justify="space-between" bg="green.50" borderBottom="1px solid" borderColor="green.50">
												<Text fontSize="sm">{v.label || `Variant ${i + 1}`}</Text>
												<Text fontSize="sm" fontWeight="semibold">
													${(parseFloat(String(v.price ?? '')) || 0).toFixed(2)}
												</Text>
											</Flex>
										))}
									</Box>
								</Box>
							)}

							{facPrices.length > 0 && variants.length === 0 && (
								<Box>
									<Badge colorScheme="blue" mb={2}>Facility prices</Badge>
									<Text fontSize="sm" color="gray.600">{facPrices.length} facility override(s)</Text>
								</Box>
							)}

							{groupPrices.length > 0 && variants.length === 0 && (
								<Box>
									<Badge colorScheme="teal" mb={2}>Group prices</Badge>
									<Text fontSize="sm" color="gray.600">{groupPrices.length} price group override(s)</Text>
								</Box>
							)}
						</Stack>
					</ModalBody>
					<ModalFooter borderTop="1px solid" borderColor="gray.100">
						<Button variant="ghost" mr={3} onClick={() => setIsPreviewOpen(false)}>
							Back to Edit
						</Button>
						<Button colorScheme="teal" onClick={handleConfirmSave} isLoading={isSubmitting}>
							Confirm Save
						</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>
		</>
	);
};

const mapStateToProps = (state) => ({
	facListLoading: state.facilities.facListLoading,
	facList: state.facilities.facList,
	categories: state.categories.categories,
	catloading: state.categories.loading,
	priceGroups: state.priceGroups.groups,
});

const mapDispatchToProps = {
	addProduct,
	getAllFacilityList,
	getAllCategories,
	getAllPriceGroups,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddProduct);
